import {
  type TCianApiSiteV1FilterPikNewbuildingsResponse,
  fetchCianApiSiteV1FilterPikNewbuildings,
} from 'shared/repositories/monolith-python/cian-api/site/v1/filter-pik-newbuildings';
import { type IFilterPikNewbuildingsResponseSchema82 } from 'shared/repositories/monolith-python/entities/schemas/FilterPikNewbuildingsResponseSchema82';
import { type IFilterPikNewbuildingsRequest } from 'shared/types/residentials';
import { type IApplicationContext } from 'shared/types/applicationContext';

import { assertNotFoundError } from './assert/assertNotFoundError';

type GetFilteredResidentialComplexesParams = {
  context: IApplicationContext;
  parameters: IFilterPikNewbuildingsRequest;
};

export const getFilteredResidentialComplexes = async ({
  context,
  parameters,
}: GetFilteredResidentialComplexesParams): Promise<number[]> => {
  const {
    httpApi,
    custom: { subdomain },
  } = context;

  const response = await fetchCianApiSiteV1FilterPikNewbuildings<
    TCianApiSiteV1FilterPikNewbuildingsResponse,
    TCianApiSiteV1FilterPikNewbuildingsResponse
  >({
    config: { subdomain },
    httpApi,
    parameters,
  });

  assertNotFoundError(response);

  return (response.response as IFilterPikNewbuildingsResponseSchema82).data.newbuildingIds || [];
};
